import { startLoading, stopLoading } from 'actions';
import api from 'api';
import { ModuleCycleEnum } from 'constants/types/CycleModule';
import { IThunkAction } from 'constants/types/IThunkAction';
import { errorHandler } from 'helpers/errorHandler';

export const updateCycleModule = (
  id: number | undefined,
): IThunkAction => async (dispatch, getState): Promise<void> => {
  const semesterId = getState().semester.newSemester?.id;
  try {
    startLoading()(dispatch);
    const response = await api.get(`/CycleModules/details/${semesterId}/${id}`);
    dispatch({
      type: ModuleCycleEnum.FETCH_SEMESTER_MODULE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    errorHandler(error);
    dispatch({
      type: ModuleCycleEnum.FETCH_SEMESTER_MODULE_FAILURE,
      error,
    });
  }
  stopLoading()(dispatch);
};
